import { auth0Token } from './authUtils'
import { JobExportExtension } from 'common/contexts/types'
import { API_BASE_URL } from 'common/utils/apiConstants'

/**
 * Function to download a file through an API fetch request
 *
 * @param jobId - ID of the scheduled export job to download
 * @param fileName - Name for the downloaded file
 */
export const downloadFileFromJob = async (
  jobId: string,
  fileName: string,
  extension?: JobExportExtension
): Promise<string> => {
  const bearerToken = await auth0Token.getAccessTokenSilently()

  return fetch(`${API_BASE_URL}/jobs/${jobId}`, {
    headers: { Authorization: `Bearer ${bearerToken}` }
  })
    .then((response) => response.blob())
    .then((bytes) => {
      const elm = document.createElement('a')

      elm.href = URL.createObjectURL(bytes)
      elm.setAttribute('download', fileName + extension)
      elm.click()
      elm.remove()

      return `Exported file:\n${fileName}${extension || ''}`
    })
    .catch((err) => {
      console.log(err)

      return 'Exporting file unsuccessful'
    })
}

export const downloadFileFromDetailViewImport = async (
  fileGroupId: number,
  fileName: string
): Promise<void> => {
  const bearerToken = (await auth0Token.getAccessTokenSilently()) as string

  fetch(
    `${API_BASE_URL}/datamanagement/download/csvfile?fileGroupId=${fileGroupId}&fileName=${fileName}`,
    { headers: { Authorization: `Bearer ${bearerToken}` } }
  )
    .then((response) => response.blob())
    .then((bytes) => {
      const elm = document.createElement('a')

      elm.href = URL.createObjectURL(bytes)
      elm.setAttribute('download', fileName)
      elm.click()
    })
    .catch((err) => {
      console.log(err)
    })
}
